import { useSchedule } from 'scenes/SmartRules/hooks';

export const Schedule = ({ data }) => {
  return useSchedule({ data });
};
